import { Component, ContentChild, Input } from '@angular/core';
import { AlertActionsDirective } from './alert-actions.directive';
import { NgClass, NgSwitch, NgSwitchCase, NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-alert',
    templateUrl: 'alert.component.html',
    standalone: true,
    imports: [NgClass, NgSwitch, NgSwitchCase, NgIf, NgTemplateOutlet],
})
export class AlertComponent {
    @Input() type: string = 'info';
    @Input() label: string;

    @ContentChild(AlertActionsDirective) alertActions: AlertActionsDirective;

    constructor() {}
}
